import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import '../../assets/css/legacyCMSStyles.css'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import { Button } from '@material-ui/core';
import Modal from '@material-ui/core/Modal'
import IconButton from '@material-ui/core/IconButton';

import RepairsOpen from '../repairs/RepairsOpen';
import RepairDetails from '../repairs/RepairDetails';
import RepairsClosed from './RepairsClosed';
import RepairsDashboard from './RepairsDashboard';
import AddRepairView from '../repairs/AddRepairView'

import ModalCloseRepairs from './ModalCloseRepairs';
import { ChevronList } from '../../utils/engageComponents'


import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { sweetAlert } from "../../components/Alert/sweetAlert";

import { 
    CancelRepairs,getAllRepairs, getOpenRepairs, getCloseRepairs,GetRepairsFilters,getHistoricDashboard, CloseRepairs, ScheduleWorkOrder
} from '../../actions/repairAction';

import { getRoomsByCommunityId  } from '../../actions/roomAction';
import { getItemsByCommunity  } from '../../actions/itemAction';
import { getIssuesByCommunity  } from '../../actions/issueAction';


import SetUpBase from '../setup/SetUpBase';
import LegacyAppBar from '../ui/LegacyAppBar';
import UptRepairsEmailComponent from '../repairs/UptRepairsEmailComponent'


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
            //style={{minHeight:'80%'}}
        >
            {value === index && (
                <Box >
                    <Grid>
                        {children}
                    </Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class RepairsBase  extends Component{
    constructor(props){
        super(props);

        this.state = {
            openAddRepair: false,
            //tabs
            tabSelected: 0,

            repairsSelected: [],

            //Repair details
            openRepairDetails: false,
            repairSelectedForDetails:{},
            repairSelectedForDetailsStatus:undefined,

            //Schedule repair modal
            stepCounter: 0,
            disabledBackIcon: true,
            disabledFowardIcon: false,

            communityId:localStorage.getItem('communityId'),
            SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},
        }

    };

    //#region methods
    
    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };

    handleTabChange = (event, newValue) =>{
        if(newValue < -1)
            return undefined
        
            //TODO
        this.setState({
            tabSelected: newValue, 
            openAddRepair: false,
            //tabs

            repairsSelected: [],

            //Repair details
            openRepairDetails: false,
            repairSelectedForDetails:{},
            repairSelectedForDetailsStatus:undefined,

            updStateForFilters:{},
        })
    }

    selectRepairForDetailsHandler = (openRepairDetails, repairSelectedForDetails, repairSelectedForDetailsStatus) =>{
        this.setState({openRepairDetails: openRepairDetails, repairSelectedForDetails: repairSelectedForDetails, repairSelectedForDetailsStatus: repairSelectedForDetailsStatus, repairsSelected: Array.of(repairSelectedForDetails)})
    }

    repairsSelectedHandler = (repairsSelected) =>{
        try{
            this.setState({repairsSelected: repairsSelected})
        }catch(err){
            return undefined;
        }
    }

    RepairSelectedForCancelHandler = (repairsSelected) => {
        try{
            this.setState({repairsSelected: repairsSelected, showModalCloseRepairs: true, isCancel:true})
        }catch(err){

        }
    }

    UpdateFiltersHandler = (updatedState) =>{
        try{
            this.setState({updStateForFilters: updatedState})
        }catch(err){
            return undefined
        }
    }

    getAllRepairsOnAddView = () =>{
        try{

            if(!this.props.getAllRepairs)
                return undefined
            setTimeout(() => {
                this.props.getAllRepairs(localStorage.getItem('communityId'));
            }, 600);
        }catch(err){
            return undefined
        }
    }

    CleanCloseRepairsModal = () => {

        this.setState({ showModalCloseRepairs: false,})
    };

    OnCancelHandler = () => {
        this.CleanCloseRepairsModal();
        this.setState({ isCancel: false, repairSelectedForDetails:undefined, repairsSelected:[] });
    };

    OnCancelRepairs = () =>{
        try{
            let arrayOfRepairsToCancel = this.state.repairsSelected ? this.state.repairsSelected : []
            arrayOfRepairsToCancel = arrayOfRepairsToCancel.map(repair => {
                return { _id: repair._id }
            }
            );
    
            if (arrayOfRepairsToCancel) {
                this.props.CancelRepairs(arrayOfRepairsToCancel, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
            }
    
            this.CleanCloseRepairsModal();
    
            setTimeout(() => {
                if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0))
                    this.getRepairs();

                this.setState({ repairsSelected: [], openRepairDetails: false });    
            }, 600);

        }catch(err){
            return undefined
        }
    }

    OnCloseHandler = () =>{
        try{
            let arrayOfRepairsToClose = this.state.repairsSelected ? this.state.repairsSelected : []

            const profileKeyCloakObj = localStorage.getItem('ky') ? JSON.parse(localStorage.getItem('ky')) : undefined;
            let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile) ? profileKeyCloakObj.profile : undefined;
            let closedByName = (profileObject && profileObject.username) ? profileObject.username : undefined;    
    
            arrayOfRepairsToClose = arrayOfRepairsToClose.map(repair => {
                return { _id: repair._id, userName: closedByName }
            });
    
            if (arrayOfRepairsToClose) {
                this.props.CloseRepairs(arrayOfRepairsToClose, this.state.SweetAlertStyles? this.state.SweetAlertStyles: {});
            }
    
            this.CleanCloseRepairsModal();
    
            setTimeout(() => {
                if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0))
                    this.getRepairs();
    
                this.setState({ repairsSelected: [], openRepairDetails: false });
    
            }, 600);
        }catch(err){
            return undefined;
        }
    }


    closeDetails = () =>{
        try{
            this.setState({openRepairDetails:false, repairSelectedForDetails: undefined, repairsSelected:[]})
        }catch(err){
            return undefined;
        }
    }


    getRepairs = async () => {
        this.props.getAllRepairs(localStorage.getItem('communityId'));
        await this.props.getHistoricDashboard(localStorage.getItem('communityId'));

        await this.getOpenScrollingRepair();
        await this.getCloseScrollingRepair();
    };

    getOpenScrollingRepair = async(page) => {
        let resOpenRequest = undefined;
        if(this.state.filtersOpenedApply){
            resOpenRequest = await this.GetRepairsWithFilters();
        }else{
            resOpenRequest= await this.props.getOpenRepairs(localStorage.getItem('communityId'), page);
        }

        return (resOpenRequest && resOpenRequest.ok)? true: false
    }
    getCloseScrollingRepair = async (page) => {

        let resCloseRequest = undefined;
        if(this.state.filtersClosedApply){
            resCloseRequest = await this.GetRepairsWithFilters();
        }else{
            resCloseRequest = await this.props.getCloseRepairs(localStorage.getItem('communityId'), page);
        }

        return (resCloseRequest && resCloseRequest.ok)? true: false
    }


    handleCommunityChange =()=>{
        const id = localStorage.getItem('communityId');
        this.setState({repairsSelected:[], communityId:id})
        this.getRepairs(); 
        this.props.getRoomsByCommunityId(id, true, true)
        this.props.getItemsByCommunity(id, true)
        this.props.getIssuesByCommunity(id, true)



    }

    async GetRepairsWithFilters(){

        const id = localStorage.getItem('communityId');
        const page =  this.state.currentPageOpended 
        const objFilters = this.state.filtersOpenedObj
        const searchValue =  (this.state.searchOpenedValue && this.state.searchOpenedValue.length > 0) ? this.state.searchOpenedValue: ''
        const sort = this.state.sortOpenedColumn? this.state.sortOpenedColumn :  'createdDate'
        const sortDirection = this.state.sortOpenedDesc 

        const res = await this.props.GetRepairsFilters(id, this.state.tabSelected, objFilters, page, searchValue, sort, sortDirection );
        return res
    };

    OpenModalHandler = () => {
        if (this.state.repairsSelected && this.state.repairsSelected.length > 0) {

            this.setState({ showScheduleRepairModal: true });
        }
        else {
            return;
            // const message = 'please select at least 1 work order'
            // sweetAlert('error', message, 'alert_RepairsV2_NoWorkOrderSelected_Error');
        }

    };


    onArrowClick = (order, placeHolder) => {


        if (placeHolder === 'hr') {
            let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
            let hour = hourObject.number ? hourObject.number : 0;

            if (order === 'Up') {

                if ((hour + 1) < 13) {
                    hour = hour + 1;
                }
            }
            else {
                if ((hour - 1) > 0) {
                    hour = hour - 1;
                }
            }

            hourObject.number = hour;
            hourObject.text = ('0' + hour).slice(-2);

            this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'min') {
            let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
            let minute = minuteObject.number ? minuteObject.number : 0;
            if (order === 'Up') {

                if ((minute + 1) < 60) {
                    minute = minute + 1;
                }
            }
            else {
                if ((minute - 1) > -1) {
                    minute = minute - 1;
                }
            }

            minuteObject.number = minute;
            minuteObject.text = ('0' + minute).slice(-2)

            this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'AM') {
            let dayTime = 'AM';
            if (this.state.dayTime === undefined || this.state.dayTime.text === 'PM') {
                dayTime = 'AM';
            }
            else {
                dayTime = 'PM';
            }

            this.setState({ dayTime: { text: dayTime }, fixedOptionSelected: undefined });
        }
    }

    CleanScheduleModal = () => {

        this.setState({
            showScheduleRepairModal: false,
            scheduleDay: undefined,
            hourSelected: undefined,
            minuteSelected: undefined,
            dayTime: undefined,
            fixedOptionSelected: undefined,
        })
    };

    MakeRepairDate = () =>  {
        try{
            if (this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined)
                return

    
            const now = moment(new Date()).startOf('minute');
            let repairDate = moment(new Date());
    
            if (this.state.scheduleDay && this.state.hourSelected && this.state.minuteSelected && this.state.dayTime) {    
                repairDate = moment(this.state.scheduleDay.format('MM-DD-YYYY') + ' ' + this.state.hourSelected.number + ':' + this.state.minuteSelected.number + ' ' + this.state.dayTime.text, 'MM-DD-YYYY hh:mm A');    
            }
    
            if (repairDate < now) {
                let nowHour = now.hour() > 12 ? now.hour() - 12 : now.hour();
                let nowMinute = now.minutes();
                let nowDayTime = now.hour() > 11 ? 'PM' : 'AM';
                let nowDay = now.clone().startOf('day');
    
    
                let hourObject = {
                    number: undefined,
                    text: '',
                }
    
                let minuteObject = {
                    number: undefined,
                    text: '',
                }
    
                const datTimeObject = {
                    text: nowDayTime,
                }
    
    
                if (nowHour === undefined) {
                    hourObject = {
                        number: undefined,
                        text: '',
                    }
                } else {
    
                    hourObject = {
                        number: nowHour,
                        text: ('0' + nowHour).slice(-2),
                    }
                }
    
                if (nowMinute === undefined) {
                    minuteObject = {
                        number: undefined,
                        text: '',
                    }
                } else {
    
                    minuteObject = {
                        number: nowMinute,
                        text: ('0' + nowMinute).slice(-2),
                    }
                }
    
    
    
                this.setState({
                    hourSelected: hourObject,
                    minuteSelected: minuteObject,
                    dayTime: datTimeObject,
                    scheduleDay: nowDay,
                });
    
    
                const message = `Cannot select a time in the past`
    
                sweetAlert('error', message, 'alert_RepairsV2_PastTime_Error', this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
    
            } else {
    
                if (repairDate &&
                    this.state.hourSelected &&
                    this.state.minuteSelected &&
                    this.state.dayTime &&
                    this.state.scheduleDay) {
    
                    this.ScheduleRepairHandler(repairDate);
                    this.CleanScheduleModal();
                    if (this.state.openRepairDetails === false) {
                        this.setState({ repairsSelected: [] });
    
                    }
    
                    if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)) {
                        setTimeout(() => {
                            this.getRepairs();
                        }, 200);
    
                        // if (this.state.openRepairDetails === true && this.state.repairSelectedForDetails) {
                        //     setTimeout(() => {
    
                        //         const idRepairSelected = this.state.repairSelectedForDetails._id;
                        //         const repairWithSelectedRepairId = this.props.tableData.find(repair => repair._id === idRepairSelected);
    
                        //         if (repairWithSelectedRepairId) {
                        //             this.setState({ openRepairDetails: false });
    
                        //             this.setState({ repairSelectedForDetails: { ...repairWithSelectedRepairId }, openRepairDetails: true });
    
                        //         }
    
                        //     }, 300);
    
                        //}
                    }
    
                } else {
                    const message = `Please indicate a day and time to schedule the order`
    
                    sweetAlert('error', message, 'alert_RepairsV2_NoYimeSelected_Error', this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
                }
            }
        }catch(err){
            return undefined
        }
    };

    AddStep = (step) => {

        let newValue = this.state.stepCounter + step;
        this.setState({ stepCounter: newValue });

        if (newValue === 1)
            this.setState({ disabledBackIcon: false, disabledFowardIcon: true });
        else
            this.setState({ disabledBackIcon: true, disabledFowardIcon: false });
    }

    handleDayClick = (day, today) => {

        if (day >= today) { this.setState({ scheduleDay: day }) }

        if (this.state.fixedOptionSelected !== undefined) {

            setTimeout(() => {

                const daySelected = moment(this.state.scheduleDay).format('DDDD');
                const todayD = moment(today).format('DDDD');
                const Tomorrow = moment(today).add(1, 'day').format('DDDD');

                if ((this.state.fixedOptionSelected === 1 || this.state.fixedOptionSelected === 2) && daySelected !== todayD) {

                    this.setState({ fixedOptionSelected: undefined });

                }
                else if (this.state.fixedOptionSelected === 3 && daySelected !== Tomorrow) {

                    this.setState({ fixedOptionSelected: undefined });

                }
            }, 300);
        }
    }

    SelectOptionForRepair = (scheduleDate, option) => {

        let hour = scheduleDate.hour() > 12 ? scheduleDate.hour() - 12 : scheduleDate.hour();
        let minute = scheduleDate.minutes();
        let dayTime = scheduleDate.hour() > 11 ? 'PM' : 'AM';
        let daySelected = scheduleDate.clone().startOf('day');

        if (this.state.fixedOptionSelected && this.state.fixedOptionSelected === option) {
            option = undefined;
            hour = undefined;
            minute = undefined;
            dayTime = undefined;
            daySelected = undefined;
        };

        let hourObject = {
            number: undefined,
            text: '',
        }

        let minuteObject = {
            number: undefined,
            text: '',
        }

        const datTimeObject = {
            text: dayTime,
        }


        if (hour === undefined) {
            hourObject = {
                number: undefined,
                text: '',
            }
        } else {

            hourObject = {
                number: hour,
                text: ('0' + hour).slice(-2),
            }
        }

        if (minute === undefined) {
            minuteObject = {
                number: undefined,
                text: '',
            }
        } else {

            minuteObject = {
                number: minute,
                text: ('0' + minute).slice(-2),
            }
        }


        this.setState({
            fixedOptionSelected: option,
            hourSelected: hourObject,
            minuteSelected: minuteObject,
            dayTime: datTimeObject,
            scheduleDay: daySelected,
        });


    }

    onChangeHandler = (e, placeholder) => {

        let timeValue = e.target.value.slice(-2)

        if (placeholder === 'hr') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 12)) {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = 0;

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            } else {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = Number(e.target.value);

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'min') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = 0;

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            } else {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = Number(e.target.value.slice(-2));

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'AM') {
            if (!(e.target.value === 'AM' || e.target.value === 'PM')) {
                this.setState({ dayTime: { text: 'AM' }, fixedOptionSelected: undefined });
            }
        }
    }

    ScheduleRepairHandler = (scheduleDate, showAlerts = true) => {
        const scheduleRepairDate = new Date(scheduleDate);
        const ArrayRepairs = this.state.repairsSelected ? this.state.repairsSelected : [];
        const profileKeyCloakObj = localStorage.getItem('ky') ? JSON.parse(localStorage.getItem('ky')) : undefined;
        let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile) ? profileKeyCloakObj.profile : undefined;
        const givenName = localStorage.getItem('givenName')? localStorage.getItem('givenName') : '';
        const familyName = localStorage.getItem('familyName')? localStorage.getItem('familyName') : '';
        const name = `${givenName} ${familyName}`;
        let username = (profileObject && profileObject.username) ? profileObject.username : name? name : undefined;

        let scheduleObject = {
            userName: username,
            scheduleDate: scheduleRepairDate ? scheduleRepairDate : undefined
        };


        if (scheduleRepairDate) {
            if (ArrayRepairs) {
                ArrayRepairs.forEach(
                    item => {
                        if (scheduleObject && scheduleObject.userName && scheduleObject.scheduleDate) {
                            this.props.ScheduleWorkOrder(item._id, item, scheduleObject, showAlerts, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {})
                        }
                    });
            }
        }



    };

  

    openAddRepairHandler = (openAddRepairState) =>{
        try{
            this.setState({showAddRepairView: openAddRepairState})
        }catch(err){
            return undefined;
        }
    }

    CancelAddRequestHandler = async () =>{
        this.setState({tabValue: 1, showAddRepairView: false, submitRepair: false, enableSubmitRepairBtn: false})
        await this.getRepairs()
    }

    enableSubmitRepairBtnHandler = (state) =>{
        try{
            let enableSubmitRepairBtn =  state? state : false;

            this.setState({enableSubmitRepairBtn: enableSubmitRepairBtn, submitRepair: false});

        }catch(err){
            return undefined;
        }
    }
    //#endregion

    //#region Components

    TabsHeaders = ({headers}) =>{
        if(!headers || headers.length === 0)
            return undefined;

        return(
            <Grid item container style={{height:'100%'}}>
                <Tabs
                    value={this.state.tabSelected}
                    onChange={this.handleTabChange}
                    aria-label="full width tabs repairs"                    
                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                    className='LTabHeaderContainer'
                >
                    <Tab label={`Dashboard`} className={(this.state.tabSelected === 0) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Opened`} className={(this.state.tabSelected === 1) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Closed`} className={(this.state.tabSelected === 2) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true} />
                    <Tab label={`Set Up`} className={(this.state.tabSelected === 3) ? "LTabStyles LSelectedTabStyle" : "LTabStyles"} {...this.a11yProps(3)} disableRipple={true} disableFocusRipple={true} />
                </Tabs>
            </Grid>
        )
    }
    
        

    TabsContent = () =>{
        return(            
            // 
            <Grid item container xs={12} className="LTabContentContainer"  justifyContent='center' >
                <Grid item container >
                    <SwipeableViews
                        axis={'x'}
                        index={this.state.tabSelected}
                        onChangeIndex={this.handleChangeIndex}
                        style={{width:'100%', height:'100%'}}
                    >
                        <TabPanel value={this.state.tabSelected} index={0} dir={'x'}>
                            <RepairsDashboard/>
                        </TabPanel>
                        <TabPanel value={this.state.tabSelected} index={1} dir={'x'} >
                            <Grid item container xs={12}>
                                <RepairsOpen  
                                    onRepairSelectedForDetails = {this.selectRepairForDetailsHandler}  
                                    onRepairsSelected={this.repairsSelectedHandler} 
                                    onRepairSelectedForCancel = {this.RepairSelectedForCancelHandler}
                                    onUpdateFilters = {this.UpdateFiltersHandler}
                                    repairsSelected = {[...this.state.repairsSelected]}
                                    updState = {this.state.updStateForFilters}
                                    communityId={this.state.communityId}
                                />
                            </Grid>
                        </TabPanel>
                        <TabPanel value={this.state.tabSelected} index={2} dir={'x'}>
                            <RepairsClosed
                                onRepairSelectedForDetails = {this.selectRepairForDetailsHandler}  
                                communityId={this.state.communityId}
                            />
                        </TabPanel>
                        <TabPanel value={this.state.tabSelected} index={3} dir={'x'} >
                            <Grid item container style={{minHeight:'692px'}}>
                                <SetUpBase
                                    communityId={this.state.communityId}
                                />
                            </Grid>
                        </TabPanel>
                    </SwipeableViews>
                </Grid>
            </Grid>
        )
    }

    RepairTabComponent = () =>{
        const headers = ['Dashboard','Opened','Closed','Set Up'];
        const headerHeight = '60px'

        return(
            <Grid item container alignContent='flex-start'>
                <Grid item container xs={12} alignContent='flex-end' style={{padding:'0px 10px', height:headerHeight}}>
                    <Grid item container>
                        <this.TabsHeaders headers={headers}/>
                    </Grid>
                </Grid>                
                <Grid item container xs={12} className="LTabContentContainer" alignContent='flex-start' style={{height:`calc(100% - ${headerHeight})`}}>
                    <this.TabsContent/>                
                </Grid>                
            </Grid>
        )
    }

    GetRepairsButtons = () =>{
        return (
            <Grid item container justifyContent='flex-start' alignContent='center'>
                {
                    (this.state.showAddRepairView)?
                    <Grid item container justifyContent='flex-start' alignContent='center'>
                        <Grid item>
                            <this.SubmitBtn/>
                        </Grid>
                        <Grid item>
                            <this.CancelAddRepairBtn/>
                        </Grid>
                    </Grid>
                    :
                    (this.state.repairsSelected && this.state.repairsSelected.length > 0 )?
                        <Grid item container justifyContent='flex-start' alignContent='center'>
                            {
                                (this.state.openRepairDetails && this.state.repairSelectedForDetails)?
                                <Grid item style={{display:'flex', cursor:'pointer'}} onClick={() => this.closeDetails()}>
                                    <Grid item style={{paddingLeft:'10px', display:'flex'}}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                            alt='return'
                                            className="LBackArrow"
                                        />
                                    </Grid>
                                    <Grid item style={{paddingLeft:'10px', alignSelf:'center', color:'#105a88', fontSize:'22px', fontFamily:'Gotham-Bold'}}>Repairs</Grid>
                                </Grid>
                                :
                                undefined
                            }
                            
                            {
                                (this.state.tabSelected === 1)?
                                    <>
                                        <Grid item>
                                            <this.ScheduleBtn/>
                                        </Grid>
                                        <Grid item>
                                            <this.CompleteBtn/>
                                        </Grid>
                                        <Grid item>
                                            <this.CancelBtn/>
                                        </Grid>
                                    </>
                                :
                                undefined
                            }
                        </Grid>
                        :
                        (this.state.tabSelected === 1)?
                        <Grid item container justifyContent='flex-start' alignContent='center'>
                            <Grid item>
                                <this.AddRepairBtn/>
                            </Grid>
                        </Grid>
                        :
                        undefined
                }
            </Grid>
        )
    }

    SubmitBtn = () =>{
        const cursor= this.state.enableSubmitRepairBtn? 'pointer':'not-allowed';
        const opacity= this.state.enableSubmitRepairBtn? '':'56%';
        const handler =this.state.enableSubmitRepairBtn?  () => this.setState({submitRepair: true}): () => {}
        return (            
            (this.state.enableSubmitRepairBtn)?
            <Grid item container style={{paddingLeft:'10px', cursor: cursor, opacity:opacity}}>
                <this.BtnComponent width={'100px'} backgroundColor={'#009edd'} color={'#ffffff'} text={'Submit'} cursor={cursor} onClickHandler={handler}/>
            </Grid>
            :
            <Grid item container></Grid>
        )
    }

    CancelAddRepairBtn = () =>{
        return(
            <Grid item container style={{paddingLeft:'10px'}}>
                <this.BtnComponent  width={'100px'} border={'3px solid #009edd'} color={'#009edd'} text={'Cancel'} onClickHandler={() => this.CancelAddRequestHandler()}/>
            </Grid>
        )
    }

    AddRepairBtn = () =>{
        return (
            <Grid item container style={{paddingLeft:'10px'}}>
                <this.BtnComponent width={'200px'} backgroundColor={'#009edd'} color={'#ffffff'} text={'Add Repair Request'} onClickHandler={() => this.openAddRepairHandler(true)}/>
            </Grid>
        )
    }

    ScheduleBtn = () =>{
        return (
            <Grid item container style={{paddingLeft:'10px'}}>
                <this.BtnComponent width={'100px'} backgroundColor={'#729bb5'} color={'#f0efef'} text={'Schedule'} onClickHandler={() => this.OpenModalHandler()}/>
            </Grid>
        )
    }

    CancelBtn = () =>{
        return (
            <Grid item container  style={{paddingLeft:'10px'}}>
                <this.BtnComponent width={'100px'} border={'3px solid #009edd'} color={'#009edd'} text={'Cancel'} onClickHandler={() => this.setState({showModalCloseRepairs: true, isCancel:true})}/>
            </Grid>
        )
    }

    CompleteBtn = () =>{
        return (
            <Grid item container  style={{paddingLeft:'10px'}}>
                <this.BtnComponent width={'100px'} backgroundColor={'#69c9a6'} color={'#ffffff'} text={'Complete'} onClickHandler={() => this.setState({showModalCloseRepairs: true, isCancel:false})}/>
            </Grid>
        )
    }

    BtnComponent = ({backgroundColor, color,height,width, text, onClickHandler, border, cursor}) =>{
        const bg = backgroundColor? backgroundColor : '';
        const c = color? color : '#ffffff';
        const h = height? height: '40px'
        const brd = border? border:'';

        return(
            <Button className='btn_text_styles'  style={{borderRadius:'7px',fontSize:'18px', textTransform:'none', height:h, backgroundColor:bg, border:brd, color: c}}  onClick={ onClickHandler} disableRipple= {true} disableFocusRipple={true}>
                {text}
            </Button>
        )
    }

    RenderModalDayComponent = ({ daysToAdd }) => {

        let day = "";
        if (this.state.stepCounter === 0)
            day = moment(new Date()).add(daysToAdd, 'days');
        else
            day = moment(new Date()).add(daysToAdd + 7, 'days');


        const today = moment(new Date());
        const scheduleDay = this.state.scheduleDay ? this.state.scheduleDay : undefined;
        const sameDay = day.format('yyyy/MM/DD') === today.format('yyyy/MM/DD') ? true : false;
        const isScheduleDay = scheduleDay ? scheduleDay.format('yyyy/MM/DD') === day.format('yyyy/MM/DD') : false;

        return (
            <Grid id={`Schedule_repair_day_${daysToAdd}`} item className={day < today ? "LScheduleModalDisabledCell" : "LScheduleModalCell"} onClick={() => this.handleDayClick(day, today)}>
                <Grid item className="LDayTitle">{day.format('ddd').toUpperCase()}</Grid>
                <Grid item className={isScheduleDay ? "LScheduleModalDate LScheduleModalScheduleDay" : sameDay ? "LScheduleModalDate LScheduleModalToday" : "LScheduleModalDate"}>{day.format('D')}</Grid>
            </Grid>
        );
    };
    //#endregion

    render(){
        const week = [0, 1, 2, 3, 4, 5, 6];
        return(
        <Grid item container className='LGeneralBackground' >
            <Grid item container justifyContent='center' alignItems='center' style={{height:'20vh'}}>
                <LegacyAppBar
                    dispatchActions={this.handleCommunityChange}
                    superUserVisible={!this.state.openRepairDetails && !this.state.showAddRepairView?true:false}
                    title={'Repairs'}
                />
                <Grid item container className='LHeaderButtons'>

                        {
                            (this.state.tabSelected && (this.state.tabSelected === 1 || this.state.tabSelected === 2))?
                                <this.GetRepairsButtons/>
                                :
                                undefined     
                        }

                        {
                            (this.state.tabSelected && (this.state.tabSelected === 3))?
                            <Grid item container xs={12} justify='flex-start' alignContent='center'>
                                <UptRepairsEmailComponent communityId={this.state.communityId}/>
                            </Grid>
                            :
                            undefined
                        }
                    </Grid>
                </Grid>
                <Grid item container alignContent='flex-start' style={{minHeight:'80vh'}} >
                    {
                        (this.state.showAddRepairView)?
                        <Grid item container xs={12}  style={{height:'100%'}}>
                            <AddRepairView
                                onCancel={this.CancelAddRequestHandler}
                                onSubmit = {this.state.submitRepair}
                                onEnableSubmit = {this.enableSubmitRepairBtnHandler}
                            />
                        </Grid>
                        :
                        (this.state.openRepairDetails && this.state.repairSelectedForDetails)?
                        <Grid item container xs={12} justifyContent='center' alignContent='center' style={{height:'100%'}}>
                            <Grid item xs={11} >
                                <RepairDetails
                                    repairSelectedForDetails={this.state.repairSelectedForDetails}
                                    isCommonRoom={undefined}
                                    repairSelectedForDetailsStatus={this.state.repairSelectedForDetailsStatus ? this.state.repairSelectedForDetailsStatus : this.state.repairSelectedForDetails.orderStatus}
                                    onAddView = {this.getAllRepairsOnAddView}
                                />
                            </Grid>
                        </Grid>
                        :
                        <Grid item container xs={12} style={{height:'100%'}}>
                            <this.RepairTabComponent/>
                        </Grid>
                        
                    }
                </Grid>
            

            {/* MODALS */}

            <Modal
                open={this.state.showScheduleRepairModal? this.state.showScheduleRepairModal : false}
                onClose={() => this.CleanScheduleModal()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Grid>
                    <Paper elevation={3} className="LPaperModalRepairs" square='false' color='secondary'>

                        <Grid container justifyContent='flex-start' alignItems='baseline' style={{ height: '100%' }}>
                            <Grid item container alignItems='center' className="LTitleRepairsModal">Schedule Repair</Grid>
                            <Grid item container className="RepairsScheduleModalContainer" alignItems='center' justifyContent='center'>
                                <Grid item container xs={12} justifyContent='center' alignItems='center' className="fixedOptionContainer">
                                    <Grid id='Schedule_modal_now_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "LScheduleModalFixedOptionSelected" : "LScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()), 1)}>Now</Grid>
                                    {
                                        moment(new Date()).hour() < 12 ?
                                            <Grid id='Schedule_modal_noon_today_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "LScheduleModalFixedOptionSelected" : "LScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                            :
                                            undefined
                                    }
                                    {
                                        moment(new Date()).day() !== 6 ?
                                            <Grid id='Schedule_modal_noon_tomorrow_option' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "LScheduleModalFixedOptionSelected" : "LScheduleModalFixedOption"} onClick={() => this.SelectOptionForRepair(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                            :
                                            undefined
                                    }
                                </Grid>

                                <Grid item container xs={12} alignItems='center' justifyContent='center' className="contentModal">
                                    <Grid item container xs={1} justifyContent='center' alignItems='center' disableFocusRipple={true} disableRipple={true}>
                                        <IconButton id='device_messageModal_schedulemessage_backwardarrow' aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon} disableTouchRipple={true} disableRipple={true} disableFocusRipple={true}>
                                            <ArrowBackIosIcon style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#1f1f1f': '#f0efef'  }}  disableFocusRipple={true} disableRipple={true} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item container xs={10} alignContent='center' justifyContent='center' className="LDaysRow">
                                        {
                                            week ? week.map(
                                                day => {

                                                    return (
                                                        <this.RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                    );
                                                }
                                            ) :
                                                undefined
                                        }
                                    </Grid>
                                    <Grid item container xs={1} justifyContent='center' alignItems='center'>
                                        <IconButton id='device_messageModal_schedulemessage_forwardarrow' aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon} disableFocusRipple={true} disableRipple={true}>
                                            <ArrowForwardIosIcon style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#1f1f1f': '#f0efef'  }}/>
                                        </IconButton>
                                    </Grid>
                                </Grid>

                                    <Grid item container xs={12} justifyContent='center' alignItems='center' className="contentModalNoOpacity">
                                        
                                        <Grid item container xs={9} justifyContent='space-between' className="LScheduleModalTimeList">
                                            <Grid item container xs={4}>
                                                <ChevronList
                                                    idToSet='Schedule_repair_hr'
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    optionSelected={this.state.hourSelected}
                                                    placeHolder='hr'
                                                    textClass={'LChevronListText'}
                                                    buttonClass={'LChevronListButton'}
                                                />
                                            </Grid>
                                            <Grid item xs={1} className="ModalColon">:</Grid>
                                            <Grid item xs={4}>
                                                <ChevronList
                                                    idToSet='Schedule_repair_min'
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    optionSelected={this.state.minuteSelected}
                                                    placeHolder='min'
                                                    textClass={'LChevronListText'}
                                                    buttonClass={'LChevronListButton'}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <ChevronList
                                                    onArrowClick={this.onArrowClick}
                                                    onChangeHandler={this.onChangeHandler}
                                                    optionSelected={this.state.dayTime}
                                                    placeHolder='AM'
                                                    idToSet='Schedule_repair_AM-PM'
                                                    textClass={'LChevronListText'}
                                                    buttonClass={'LChevronListButton'}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item container className="scheduleModalButtonsContainer alingCenter" direction='row'>
                                        <Grid item container className="LRepairsModalButtonCancel alingCenter">
                                            <Grid id='Schedule_modal_cancel_btn' item container className="alingCenter" onClick={() => this.CleanScheduleModal()}>
                                                Cancel
                                            </Grid>
                                        </Grid>
                                        <Grid item container
                                            className={(this.state.scheduleDay === undefined || this.state.dayTime === undefined || this.state.minuteSelected === undefined || this.state.hourSelected === undefined) ? "LRepairsModalButtonSchedule LRepairsModalButtonSchedule-Disabled alingCenter" : "LRepairsModalButtonSchedule alingCenter"}
                                        >
                                            <Grid id='Schedule_modal_schedule_btn' item container className="alingCenter" onClick={() => this.MakeRepairDate()}>
                                                Schedule
                                            </Grid>
                                        </Grid>
                                    </Grid> 
                            </Grid> 
                        </Grid>
                    </Paper>
                </Grid>
            </Modal>

            <Modal
                open={this.state.showModalCloseRepairs? this.state.showModalCloseRepairs: false}
                onClose={() => this.CleanCloseRepairsModal()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ borderRadius: '9px' }}
            >
                <ModalCloseRepairs
                    actions={ this.state.repairsSelected ? this.state.repairsSelected : []}
                    OnCancelHandler={this.OnCancelHandler}
                    OnCloseHandler={this.OnCloseHandler}
                    OnCancelRepairs={this.OnCancelRepairs}
                    isCancel={this.state.isCancel}
                />
            </Modal>
        </Grid>
        )
    }
}


function mapStateToProps(state,dispatch) {
    return{}
};

export default connect(mapStateToProps,{
    getAllRepairs, 
    CancelRepairs, 
    getCloseRepairs, 
    getOpenRepairs, 
    getHistoricDashboard, 
    CloseRepairs, 
    GetRepairsFilters, 
    ScheduleWorkOrder,
    getRoomsByCommunityId,
    getItemsByCommunity,
    getIssuesByCommunity
})(RepairsBase)